import { urlPreferenciasFacturacion } from "../api/urls";

/**
 * Service para manejar las preferencias de facturación de la renovación.
 * Específicamente la bandera "mismosDatos" (Utilizar mismos datos para pago y facturación).
 */

const handleResponse = async (response) => {
    if (!response.ok) {
        const errorBody = await response.text();
        throw new Error(errorBody || "Error en la petición al servidor");
    }
    const data = await response.json();
    return data;
};

export const preferenciasPagadorService = {
    /**
     * Obtiene la preferencia de "mismos datos" para una renovación
     * @param {string} idRenovacion 
     * @returns {Promise<{transaccion: boolean, preferencias: object}>}
     */
    obtenerPreferencia: async (idRenovacion) => {
        try {
            const url = `${urlPreferenciasFacturacion}${idRenovacion}`;
            const response = await fetch(url, {
                method: "POST",
                body: JSON.stringify({ accion: "GET", idRenovacion })
            });
            return await handleResponse(response);
        } catch (error) {
            console.error("Error al obtener preferencia:", error);
            throw error;
        }
    },

    /**
     * Guarda la preferencia de "mismos datos"
     * @param {string} idRenovacion 
     * @param {boolean} mismosDatos 
     * @returns {Promise<{transaccion: boolean, preferencias: object}>}
     */
    guardarPreferencia: async (idRenovacion, mismosDatos) => {
        try {
            const url = `${urlPreferenciasFacturacion}${idRenovacion}`;
            const response = await fetch(url, {
                method: "POST",
                body: JSON.stringify({ accion: "ADD", idRenovacion, preferencias: { mismosDatos } })
            });
            return await handleResponse(response);
        } catch (error) {
            console.error("Error al guardar preferencia:", error);
            throw error;
        }
    }
};
